/* eslint-disable class-methods-use-this */
import * as marietta from '../../..';
import { ChangeItem } from '../../../view3d/webcad/ChangeItem';
import { Dialog } from '../../../core/view';
import { ThreeView, View3dGlobal } from '../../../view3d/webcad';
import MasterItemCollection from '../../collection/MasterItemCollection';
import { Fitting, MonicaObject } from '../../item';
import { ChangeFittingItem } from '../../../view3d/webcad/ChangeFittingItem';
import { ItemChangeDialog } from './index';
import { ModelLoadSystem } from '../../../view3d/webcad/WebCad3dModelLoadSystem';
import ItemSearchUtil from '../../util/ItemSearchUtil';
import ItemDetailUtil from '../../util/ItemDetailUtil';

const ITEM_LIST_SELECTOR = '#dialogItemChange .itemChangeList';
const ITEM_ID_ATTRIBUTE = 'data-name';
const ACTIVE_CLASS = 'is-active';
const CHANGE_BUTTON_ID = 'btnChangeItem';
/**
 * 3Dーアイテムの３Dイメージ変更
 * 対象：家具、設備、エクステリア
 */
export default class ItemChangeDialogStarts extends ItemChangeDialog {
  public target: any = undefined;

  private isReady:boolean = false;

  private alternativeEndItemList:MasterItemCollection[] = [];

  private alternativeGroupList: any;

  private changeTargetItem:marietta.webcad.item.MonicaObject;

  private newMasterInfo:MasterItemCollection;

  private item3did:string;

  /**
   * コンストラクタ
   */
  // eslint-disable-next-line no-useless-constructor
  constructor(draggable: boolean, modal: boolean) {
    super(draggable, modal);
  }

  /**
   * ダイアログを中心へ
   */
  public centerDialog() {
    if (this.isReady) {
      // window-heightに対する、ダイアログ高さ調整
      const h1: number = this.viewObj.querySelector('.dialogBody').getBoundingClientRect().height;

      const dialogFooter = this.viewObj.querySelector('.dialogFooter');

      const h2: number = (dialogFooter) ? this.viewObj.querySelector('.dialogFooter').getBoundingClientRect().height : 0;
      if (window.innerHeight <= (h1 + h2 + 120)) {
        (this.viewObj.querySelector('.dialogBody') as HTMLElement).style.height = `${window.innerHeight - h2 - 120}px`;
      }

      // ダイアログの幅調整
      let maxW: number = 0;
      for (let i: number = 0; i < this.viewObj.children.length; i += 1) {
        const w:number = this.viewObj.children[i].getBoundingClientRect().width;
        if (maxW < w) {
          maxW = Math.ceil(w);
        }
        (this.viewObj.children[i] as HTMLElement).style.display = 'block';
      }
      this.viewObj.style.width = `${maxW}px`;

      // ダイアログの高さ調整
      let boxHeight: number = 0;
      for (let i:number = 0; i < this.viewObj.children.length; i += 1) {
        boxHeight += this.viewObj.children[i].getBoundingClientRect().height;
      }
      this.viewObj.style.height = `${boxHeight}px`;
    }
  }

  buildContent() {
    // データがなければ取得しにいく
    let itemId;
    let guid;
    let type;
    if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '2D') {
      const item = this.target as marietta.webcad.item.MonicaObject;
      itemId = item.itemInfo.id;
      guid = item.itemInfo.guid;
      type = item.itemInfo.id.substring(0, 3);
    } else {
      itemId = this.target.userData.attribute.objectId;
      guid = this.target.userData.modelInfo.uuid;
      type = this.target.userData.modelInfo.type;
    }
    if (marietta.webcad.WebCADGlobal.masterManager.getGroupListForId(itemId)) {
      // リスト生成
      this.buildContentAfterCheck();
    } else {
      // データをサーバから取得
      marietta.webcad.WebCADGlobal.showBusy('グループ一覧取得中...');
      const p = new Promise((resolve: Function) => {
        const item:MonicaObject = marietta.webcad.WebCADGlobal.getItemByGuid(guid, type);
        if (!item.itemInfo.end_item_info) {
          marietta.webcad.WebCADGlobal.masterManager.getSymbolItemsMasterData(item.itemInfo.id, resolve);
        } else {
          marietta.webcad.WebCADGlobal.masterManager.getGroupItemsMasterData(item.itemInfo.end_item_info.item_id, resolve);
        }
      });
      p.then((list:any[] = []) => {
        this.alternativeEndItemList = [];
        for (let i:number = 0; i < list.length; i++) {
          const master:MasterItemCollection = new MasterItemCollection(list[i]);
          this.alternativeEndItemList.push(master);
        }
        const linkedItem: MonicaObject = marietta.webcad.WebCADGlobal.getItemByGuid(guid, type);
        ItemSearchUtil.moveToFront(this.alternativeEndItemList, linkedItem?.itemInfo.end_item_info?.item_id);
        this.buildContentAfterCheck();
        marietta.webcad.WebCADGlobal.hideBusy();
      });
    }
  }

  buildContentAfterCheck() {
    // ダイアログのコンテンツ生成
    const id = 'dialogItemChange';

    let title = '';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = 'アイテム変更'; break;
      default: title = 'Item Change'; break;
    }

    let contents:string;
    if (this.alternativeEndItemList.length < 1) {
      contents = '<div class="noItems">入れ替えるアイテムがありません。</div>';
    } else {
      contents = '<div class="itemChangeList"></div>';
      contents += '</div>';
    }
    let footer = '';
    if (this.alternativeEndItemList.length > 0) {
      footer += '<button id="btnCancel" value="0"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
      footer += `<button id="${CHANGE_BUTTON_ID}" value="1"><span class="jp">適用</span><span class="en">Apply</span></button>`;
    }

    this.createDialog(id, title, contents, footer);

    this.createItemList();
    this.setEvent();
    this.setSearchEvent();
    this.updateCurrent();
    this.centerDialog();
    this.checkHeight();

    document.getElementById('btnCancel')?.addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.removeDialog();
    });

    ItemDetailUtil.setApplyEnabled(document.getElementById(CHANGE_BUTTON_ID), false);
    document.getElementById(CHANGE_BUTTON_ID)?.addEventListener('click', () => {
      const btn = document.getElementById(CHANGE_BUTTON_ID);
      // 現在のボタンの内容を保存
      const originalTextJP = btn.querySelector('.jp').textContent;
      const originalTextEN = btn.querySelector('.en').textContent;

      // ボタンの色／文字を一時的に変更
      btn.classList.add('processing');
      btn.querySelector('.jp').textContent = '処理中';
      btn.querySelector('.en').textContent = 'Processing';

      if (this.changeTargetItem && this.newMasterInfo) {
        if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '3D') {
          if (this.item3did.indexOf('fit') > -1) {
            new ChangeFittingItem().changeItem(this.target, this.item3did);
          } else {
            new ChangeItem().changeItem(this.target, this.item3did);
          }
        }

        // 変更フラグを立てる
        marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = true;

        // 建具の場合は、高さ設定などを初期化する
        if (this.changeTargetItem instanceof Fitting) this.changeTargetItem.initializeHeightSetting();
        this.changeTargetItem.setToEndItem(this.newMasterInfo);
        // 商品を付けた UB を確定し、あとで商品が外れたときに気づけるようにする（この操作は履歴を積まない）
        marietta.webcad.WebCADGlobal.webcad2Dmanager.commitWithoutHistory();

        // リスト更新
        marietta.webcad.WebCADGlobal.quotationItemList.flushNow();
        if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '2D') {
          marietta.webcad.WebCADGlobal.itemManager.currentItem = this.changeTargetItem;
        }
      }

      setTimeout(() => {
        // 処理が終わったら元のテキストに戻す
        btn.classList.remove('processing');
        btn.querySelector('.jp').textContent = originalTextJP;
        btn.querySelector('.en').textContent = originalTextEN;
      }, 2000); // 2秒後に元に戻す
    });

    // ウィンドウサイズ変更時
    window.addEventListener('resize', this.checkHeight);
  }

  /**
   *
   * @param itemList
   * @param key
   * @returns
   */
  createItemGroupBySize(itemList: MasterItemCollection[], key: string) {
    const groupList = itemList.reduce((r, a) => {
      r[a[key]] = r[a[key]] || [];
      r[a[key]].push(a);
      return r;
    }, Object.create(null));
    return groupList;
  }

  /**
   * アイテムリストの生成
   */
  createItemList() {
    // const alternatives = this.target.userData.attribute.alternative;
    const dir = View3dGlobal.shared.itemDir;

    let contents = '';
    if (this.alternativeEndItemList.length > 0) {
      let guid;
      let itemId;
      if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '2D') {
        const item = this.target as marietta.webcad.item.MonicaObject;
        itemId = item.itemInfo.id;
        guid = item.itemInfo.guid;
      } else {
        itemId = this.target.userData.modelInfo.code;
        guid = this.target.userData.modelInfo.uuid;
      }
      this.alternativeGroupList = this.createItemGroupBySize(this.alternativeEndItemList, 'item_width');
      const targetItem: marietta.webcad.item.MonicaObject = marietta.webcad.WebCADGlobal.getItemByGuid(guid, itemId);
      const groupId = targetItem.itemInfo.end_item_info ? targetItem.itemInfo.end_item_info.item_width : '';
      if (groupId) {
        const alternativeList = this.alternativeGroupList[groupId];
        contents += '<div class="sizeWrap">';
        contents += '<label>サイズ</label>';
        contents += '<div>';
        contents += '<select id="select_sizechange">';
        const sizeList = Object.keys(this.alternativeGroupList);
        for (let i:number = 0; i < sizeList.length; i += 1) {
          contents += `<option value="${sizeList[i]}"${Number(sizeList[i]) == groupId ? 'selected="selected"' : ''}>${sizeList[i]}</option>`;
        }
        contents += '</select>';
        contents += '</div>';
        contents += '</div>';
        contents += ItemSearchUtil.createSearchBoxHtml();
        contents += '<ul class="alternativeItemListWrap">';
        contents += this.createItemListElements(alternativeList);
        contents += '</ul>';
      } else {
        contents += ItemSearchUtil.createSearchBoxHtml();
        contents += '<ul class="alternativeItemListWrap">';
        contents += this.createItemListElements(this.alternativeEndItemList);
        contents += '</ul>';
      }
      contents += ItemSearchUtil.createEmptyMessageHtml();

      contents += ItemDetailUtil.createHtml(ItemDetailUtil.FITTING_FIELDS);
      document.querySelector('#dialogItemChange .itemChangeList').innerHTML = contents;
    }
  }

  /**
   *
   * @param itemList
   */
  createItemListElements(itemList) {
    let contents = '';
    if (Array.isArray(itemList) && itemList) {
      for (let i = 1; i <= itemList.length; i += 1) {
        const alt = itemList[i - 1];
        const imgPath = alt.hasOwnProperty('item_thumb_path') ? alt.item_thumb_path : '';
        contents += `<li data-name="${alt.item_id}" class="btnChangeItem" data-itemid="${i}" data-item3did="${alt.symbol_3d_code}">`;
        contents += `<button id="changeItem${String(i)}">`;
        contents += '<div class="imbBox">';
        contents += `<img class='itemImgThumb' src="${imgPath}"/>`;
        contents += '<div class="currentFrame"></div>';
        contents += '</button>';
        // contents += `<p><span class="jp">${alternatives[i - 1].name}</span><span class="en">${alternatives[i - 1].nameEn}</span></p>`;
        contents += '</div>';
        contents += '</li>';
      }
    }
    return contents;
  }

  /**
   * ドロップダウン変更イベント
   */
  changeSizeGroup = (e) => {
    // 別サイズの一覧に選択中のアイテムは無いため、見えないまま適用されないよう選択を外す
    this.clearSelection();
    const val = (<HTMLSelectElement> e.currentTarget).value;
    if (val) {
      const contents = this.createItemListElements(this.alternativeGroupList[val]);
      document.querySelector('#dialogItemChange .alternativeItemListWrap').innerHTML = contents;
    }
    this.applySearch(ItemSearchUtil.getQuery(document.querySelector(ITEM_LIST_SELECTOR)));
    this.updateCurrent();
    this.setEvent();
  }

  /**
   * アイテム変更イベントの生成
   */
  setEvent() {
    // 詳細のフェードアウト用の値
    const targetDetail = (<HTMLElement>document.querySelector('.selectItemDetailWrap'));
    let alternativeItemListWrapIsFading = false;
    let alternativeItemListWrapFadeEffect;
    let selectItemDetailWrapOpacity = 1; // 初期の透明度

    if (document.getElementById('select_sizechange')) {
      document.getElementById('select_sizechange').addEventListener('change', this.changeSizeGroup);
    }
    document.querySelectorAll('#dialogItemChange .itemChangeList li').forEach((elem) => {
      elem.addEventListener('click', (e) => {
        // 選択情報保持
        const self:ItemChangeDialogStarts = this;
        const itemid = (<HTMLElement> e.currentTarget).getAttribute('data-name');
        const item3did = (<HTMLElement> e.currentTarget).getAttribute('data-item3did');
        let guid;
        let itemCode;
        if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '2D') {
          const item = this.target as marietta.webcad.item.MonicaObject;
          itemCode = item.itemInfo.id;
          guid = item.itemInfo.guid;
        } else {
          itemCode = this.target.userData.modelInfo.code;
          guid = this.target.userData.modelInfo.uuid;
        }
        let target:any;
        for (let i = 0; i < this.alternativeEndItemList.length; i++) {
          if (self.alternativeEndItemList[i].item_id == itemid) {
            target = this.alternativeEndItemList[i];
            break;
          }
        }
        const targetItem: marietta.webcad.item.MonicaObject = marietta.webcad.WebCADGlobal.getItemByGuid(guid, itemCode);
        const newMasterInfo:MasterItemCollection = new MasterItemCollection(target);
        self.changeTargetItem = targetItem;
        self.newMasterInfo = newMasterInfo;
        self.item3did = item3did;

        // 選択表示
        document.querySelectorAll('#dialogItemChange .itemChangeList li').forEach((elem) => {
          elem.classList.remove('is-active');
        });
        (<HTMLElement> e.currentTarget).closest('li').classList.add('is-active');

        // 情報表示
        ItemDetailUtil.fill(this.viewObj, newMasterInfo);
        // 名称の行を足して吹き出しが高くなったため、値を入れた後にサムネイルの中央へ合わせる
        ItemDetailUtil.show(this.viewObj, elem);
        ItemDetailUtil.setApplyEnabled(document.getElementById(CHANGE_BUTTON_ID), true);

        // 詳細のフェードアウト処理をリセット
        clearInterval(alternativeItemListWrapFadeEffect);
        selectItemDetailWrapOpacity = 1;
        targetDetail.style.opacity = selectItemDetailWrapOpacity.toString();// 透明度をリセット
        alternativeItemListWrapIsFading = false;
      });
    });

    // アイテムリスト領域のスクロールを検知
    (<HTMLElement>document.querySelector('.alternativeItemListWrap'))?.addEventListener('scroll', () => {
      if (!alternativeItemListWrapIsFading) {
        alternativeItemListWrapIsFading = true;
        // selectItemDetailWrapをフェードアウト
        alternativeItemListWrapFadeEffect = setInterval(() => {
          console.log(`opacity + ${selectItemDetailWrapOpacity}`);
          if (selectItemDetailWrapOpacity <= 0) {
            clearInterval(alternativeItemListWrapFadeEffect);
            targetDetail.classList.remove('is-active');
            selectItemDetailWrapOpacity = 1;
            targetDetail.style.opacity = selectItemDetailWrapOpacity.toString();// 透明度をリセット
            alternativeItemListWrapIsFading = false;
          } else {
            selectItemDetailWrapOpacity -= 0.1; // 透明度を徐々に減少
            targetDetail.style.opacity = selectItemDetailWrapOpacity.toString();
          }
        }, 50); // この間隔で透明度を減少させる
      }
    });
  }

  /**
   * 検索欄のイベント（setEventは作り直しのたびに呼ばれるため、ここで1回だけ登録）
   */
  private setSearchEvent(): void {
    const listRoot: Element = document.querySelector(ITEM_LIST_SELECTOR);
    if (!listRoot) return;
    ItemSearchUtil.bindInput(listRoot, (query: string) => this.applySearch(query));
  }

  /**
   * 表示中のサイズの一覧に検索を当てる
   */
  private applySearch(query: string): void {
    const listRoot: Element = document.querySelector(ITEM_LIST_SELECTOR);
    if (!listRoot) return;
    ItemDetailUtil.hide(listRoot);
    // このダイアログだけ吹き出しにサイズを出すため、サイズも検索対象にする
    const matched: Set<string> = ItemSearchUtil.applyToList(listRoot, this.alternativeEndItemList, query, true);
    // 選択中のアイテムが検索で隠れたら、見えないまま適用されないよう選択を外す
    if (this.newMasterInfo && !matched.has(String(this.newMasterInfo.item_id))) this.clearSelection();
  }

  /**
   * 選択の解除
   */
  private clearSelection(): void {
    if (this.newMasterInfo) {
      document.querySelector(`${ITEM_LIST_SELECTOR} li[${ITEM_ID_ATTRIBUTE}="${this.newMasterInfo.item_id}"]`)?.classList.remove(ACTIVE_CLASS);
    }
    this.changeTargetItem = null;
    this.newMasterInfo = null;
    this.item3did = null;
    ItemDetailUtil.hide(this.viewObj);
    ItemDetailUtil.setApplyEnabled(document.getElementById(CHANGE_BUTTON_ID), false);
  }

  /**
     * 閉じるボタンが押された
     */
  close = () => {
    // ThreeView.get().controller.description();

    ThreeView.get().unSelectedObject();
    this.closeEvent();

    // ThreeView.get().controller.description();
  }

  /**
   * override
   */
  closeEvent() {
    super.closeEvent();
  }

  /*
  * カレント表示の追加
  */
  updateCurrentItemInfo() {
    let idthreed;
    let itemId;
    if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '2D') {
      const item = this.target as marietta.webcad.item.MonicaObject;
      itemId = item.itemInfo.id;
      idthreed = item.itemInfo.idthreed;
    } else {
      itemId = this.target.userData.modelInfo._id;
      idthreed = this.target.userData.modelInfo._idthreed;
    }
    const id = idthreed || itemId;
    const element = document.querySelector(`#dialogItemChange .itemChangeList [data-name='${id}']`);
    if (element) element.closest('li').classList.add('is-active');
  }

  /*
  * カレント表示の追加
  */
  updateCurrent() {
    let guid;
    let itemId;
    if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '2D') {
      const item = this.target as marietta.webcad.item.MonicaObject;
      itemId = item.itemInfo.id;
      guid = item.itemInfo.guid;
    } else {
      itemId = this.target.userData.modelInfo.code;
      guid = this.target.userData.modelInfo.uuid;
    }
    const targetItem: marietta.webcad.item.MonicaObject = marietta.webcad.WebCADGlobal.getItemByGuid(guid, itemId);

    // const id = this.target.userData.modelInfo._idthreed ? this.target.userData.modelInfo._idthreed : this.target.userData.modelInfo._id;
    const id = targetItem.itemInfo.end_item_info ? targetItem.itemInfo.end_item_info.item_id : '';
    const element = document.querySelector(`#dialogItemChange .itemChangeList [data-name='${id}']`);
    if (element) element.closest('li').classList.add('is-active');
  }

  /*
  * 高さの調整
  */
  checkHeight() {
    // #dialogItemChangeの高さを取得
    const indicatedArea = 115; // ダイアログの上下マージンの合計値
    const pageContainerHeight = document.getElementById('pageContainer').getBoundingClientRect().height;
    console.log('Height:', pageContainerHeight);
    const dialogItemChangeHeaderHeight = (<HTMLElement>document.querySelector('#dialogItemChange .dialogTitle')).getBoundingClientRect().height;
    console.log('Height:', dialogItemChangeHeaderHeight);
    const dialogItemChangeFooterHeight = (<HTMLElement>document.querySelector('#dialogItemChange .dialogFooter'))?.getBoundingClientRect().height ?? 0;
    console.log('Height:', dialogItemChangeFooterHeight);
    // dialogBodyのMAXの高さを指定
    const dialogItemChangeBodyHeight = (<HTMLElement>document.querySelector('#dialogItemChange .dialogBody'));
    dialogItemChangeBodyHeight.style.maxHeight = `${pageContainerHeight - dialogItemChangeHeaderHeight - dialogItemChangeFooterHeight - indicatedArea}px`;
  }
}
